import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 13936 18188"
    {...props}
  >
    <path
      d="m877 14473 3937-5743-3315-5117c-311-496-544-922-700-1278s-234-696-234-1028c0-336 148-635 451-906C1315 135 1679 0 2114 0c496 0 881 148 1155 438 279 291 660 836 1147 1627l2642 4276 2823-4276c229-361 430-668 594-922 164-258 319-471 471-639 155-168 323-295 512-377 188-86 405-127 655-127 447 0 812 135 1098 401 283 271 426 586 426 955 0 537-307 1266-926 2188L9242 8730l3736 5743c336 504 577 922 729 1253 151 332 229 644 229 938 0 283-69 537-204 771-136 229-328 414-574 549-250 135-529 204-844 204-336 0-619-69-852-208-230-140-418-316-561-521-144-209-414-614-807-1212l-3097-4867-3290 5010c-254 401-434 680-544 840-107 160-238 315-390 467-151 152-331 270-540 360-209 86-451 131-734 131-430 0-790-131-1073-397-283-262-426-647-426-1151 0-590 291-1315 877-2167z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
